import {
  deadlineTrafficColor,
  manualReminderTrafficColor,
  trafficColorToTone,
} from "./expediente-traffic-light.js";

const TONE_ORDER = { danger: 0, warning: 1, success: 2 };

function timestamp(value, missingValue) {
  const parsed = new Date(value || "").getTime();
  return Number.isFinite(parsed) ? parsed : missingValue;
}

export function orderExpedienteAttentionItems(
  deadlines = [],
  representedPartyGroups = [],
  { now = new Date(), manualReminders = [] } = {},
) {
  return [
    ...deadlines.map((value) => {
      const tone = trafficColorToTone(
        deadlineTrafficColor(value, representedPartyGroups, { now }),
      );
      return {
        id: `deadline:${value.id}`,
        type: "deadline",
        tone,
        date: tone === "success" ? value.startDate : value.dueDate,
        value,
      };
    }),
    ...manualReminders.map((value) => {
      return {
        id: `manual:${value.id}`,
        type: "manual",
        tone: trafficColorToTone(manualReminderTrafficColor(value, { now })),
        date: value.dueDate,
        value,
      };
    }),
  ].sort((left, right) => {
    const toneDifference =
      (TONE_ORDER[left.tone] ?? 9) - (TONE_ORDER[right.tone] ?? 9);
    if (toneDifference) return toneDifference;
    const ascending = left.tone !== "success";
    const missingValue = ascending
      ? Number.POSITIVE_INFINITY
      : Number.NEGATIVE_INFINITY;
    const leftTime = timestamp(left.date, missingValue);
    const rightTime = timestamp(right.date, missingValue);
    if (leftTime !== rightTime) {
      return ascending ? leftTime - rightTime : rightTime - leftTime;
    }
    return left.id.localeCompare(right.id);
  });
}
